import { actionSet } from './utils'
import { hideSpinner, showSpinner } from './spinner'
import FileSaver from 'file-saver'
import {
  FETCH_SATISFACTION_SURVEY_SUCCESS,
  FETCH_SATISFACTION_SURVEY_ERROR,
  CREATE_SATISFACTION_SURVEY_SUCCESS,
  CREATE_SATISFACTION_SURVEY_ERROR,
} from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

export const fetchAll = (token, manageSpinner = true) => async (dispatch) => {
  try {
    if (manageSpinner) {
      dispatch(showSpinner())
    }

    const response = await new Api(token, dispatch).get(API_URL.LIST_EVALUATIONS)
    const { data, metadata } = response

    return dispatch(
      actionSet(FETCH_SATISFACTION_SURVEY_SUCCESS, { data, metadata })
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_SATISFACTION_SURVEY_ERROR, error))
  } finally {
    if (manageSpinner) {
      dispatch(hideSpinner())
    }
  }
}

export const createEvaluation = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    const response = await new Api(token, dispatch).post(
      API_URL.CREATE_EVALUATION,
      param
    )

    dispatch(actionSet(CREATE_SATISFACTION_SURVEY_SUCCESS, response.data))
    return response.data
  } catch (error) {
    dispatch(actionSet(CREATE_SATISFACTION_SURVEY_ERROR, error))
    throw error
  } finally {
    dispatch(hideSpinner())
  }
}

export const updateEvaluation = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    const response = await new Api(token, dispatch).post(
      API_URL.UPDATE_EVALUATION,
      param
    )
    return response.data
  } finally {
    dispatch(hideSpinner())
  }
}

export const deleteEvaluation = (token, idEvaluation) => async (dispatch) => {
  try {
    dispatch(showSpinner())
    await new Api(token, dispatch).post(
      `${API_URL.DELETE_EVALUATION}?idEvaluation=${idEvaluation}`
    )
  } finally {
    dispatch(hideSpinner())
  }
}

export const downloadEvaluationReport =
  (token, idEvaluation, fileName = `avaliacoes_pesquisa_${idEvaluation}.csv`) =>
  async (dispatch) => {
    const signalController = new AbortController()

    const onClose = () => dispatch(hideSpinner())

    const onError = (error) => {
      dispatch(hideSpinner())
      return error
    }

    const onMessage = (response) => {
      const csvContent = response?.data

      if (typeof csvContent !== 'string' || csvContent.trim() === '') {
        throw new Error(
          response?.message?.message ||
            response?.message ||
            'Nao foi possivel baixar as avaliacoes.'
        )
      }

      const blob = new Blob([`\ufeff${  csvContent}`], {
        type: 'text/csv;charset=utf-8',
      })

      FileSaver.saveAs(blob, fileName)
      onClose()
    }

    dispatch(showSpinner())

    return new Api(token, dispatch)
      .eventSourceStream(
        API_URL.DOWNLOAD_EVALUATION_REPORT,
        { idEvaluation },
        null,
        signalController,
        onMessage,
        onClose,
        onError
      )
      .catch((error) => {
        onError(error)
        throw error
      })
  }
